import makeVueModal from '@/views/modal/make_vue_modal';

let contactsModal = null;

$(document).on('turbolinks:before-cache', () => {
  if (contactsModal) {
    contactsModal.destroy();
    contactsModal = null;
  }
});

$(document).on('turbolinks:load', async () => {
  const node = document.querySelector('article.v4.box_sizes');
  if (!node) { return; }

  $('button.lead', node).one('click', async ({ currentTarget }) => {
    const $node = $(currentTarget);

    contactsModal ||= makeVueModal({
      trigger: currentTarget,
      vue: {
        importComponent: async () => await import('@/vue/modals/contacts'),
        props: {
          submitUrl: $node.data('submit_url'),
          leadType: $node.data('lead-type'),
          trackEvent: $node.data('track-event'),
          trackEventLocation: $node.data('track-event-location'),
          privacyUrl: $node.data('privacy_url'),
          privacyConsentUrl: $node.data('privacy_consent_url'),
          phoneUrl: $node.data('phone_url'),
          lineUrl: $node.data('line_url'),
          whatsappUrl: $node.data('whatsapp_url'),
          telegramUrl: $node.data('telegram_url'),
          maxUrl: $node.data('max_url'),
          workTime: $node.data('work_time'),
          faqUrl: $node.data('faq_url'),
          graphqlUrl: $node.data('graphql_url')
        }
      }
    })
      .show();
  });
});
